export enum State {
  Alabama = "Alabama",
  Alaska = "Alaska",
  Arizona = "Arizona",
  Arkansas = "Arkansas",
  California = "California",
  Colorado = "Colorado",
  Connecticut = "Connecticut",
  Delaware = "Delaware",
  DistrictOfColumbia = "District of Columbia",
  Florida = "Florida",
  Georgia = "Georgia",
  Hawaii = "Hawaii",
  Idaho = "Idaho",
  Illinois = "Illinois",
  Indiana = "Indiana",
  Iowa = "Iowa",
  Kansas = "Kansas",
  Kentucky = "Kentucky",
  Louisiana = "Louisiana",
  Maine = "Maine",
  Maryland = "Maryland",
  Massachusetts = "Massachusetts",
  Michigan = "Michigan",
  Minnesota = "Minnesota",
  Mississippi = "Mississippi",
  Missouri = "Missouri",
  Montana = "Montana",
  Nebraska = "Nebraska",
  Nevada = "Nevada",
  NewHampshire = "New Hampshire",
  NewJersey = "New Jersey",
  NewMexico = "New Mexico",
  NewYork = "New York",
  NorthCarolina = "North Carolina",
  NorthDakota = "North Dakota",
  Ohio = "Ohio",
  Oklahoma = "Oklahoma",
  Oregon = "Oregon",
  Pennsylvania = "Pennsylvania",
  RhodeIsland = "Rhode Island",
  SouthCarolina = "South Carolina",
  SouthDakota = "South Dakota",
  Tennessee = "Tennessee",
  Texas = "Texas",
  Utah = "Utah",
  Vermont = "Vermont",
  Virginia = "Virginia",
  Washington = "Washington",
  WestVirginia = "West Virginia",
  Wisconsin = "Wisconsin",
  Wyoming = "Wyoming",
  Alberta = "Alberta",
  BritishColumbia = "British Columbia",
  Manitoba = "Manitoba",
  NewBrunswick = "New Brunswick",
  NewfoundlandAndLabrador = "Newfoundland and Labrador",
  NorthwestTerritories = "Northwest Territories",
  NovaScotia = "Nova Scotia",
  Nunavut = "Nunavut",
  Ontario = "Ontario",
  PrinceEdwardIsland = "Prince Edward Island",
  Quebec = "Quebec",
  Saskatchewan = "Saskatchewan",
  Yukon = "Yukon",
  Aguascalientes = "Aguascalientes",
  BajaCalifornia = "Baja California",
  BajaCaliforniaSur = "Baja California Sur",
  Campeche = "Campeche",
  Chiapas = "Chiapas",
  Chihuahua = "Chihuahua",
  Coahuila = "Coahuila",
  Colima = "Colima",
  Durango = "Durango",
  Guanajuato = "Guanajuato",
  Guerrero = "Guerrero",
  Hidalgo = "Hidalgo",
  Jalisco = "Jalisco",
  MexicoCity = "Mexico City",
  MexicoState = "Mexico State",
  Michoacan = "Michoacan",
  Morelos = "Morelos",
  Nayarit = "Nayarit",
  NuevoLeon = "Nuevo Leon",
  Oaxaca = "Oaxaca",
  Puebla = "Puebla",
  Queretaro = "Queretaro",
  QuintanaRoo = "Quintana Roo",
  SanLuisPotosi = "San Luis Potosi",
  Sinaloa = "Sinaloa",
  Sonora = "Sonora",
  Tabasco = "Tabasco",
  Tamaulipas = "Tamaulipas",
  Tlaxcala = "Tlaxcala",
  Veracruz = "Veracruz",
  Yucatan = "Yucatan",
  Zacatecas = "Zacatecas",
}

export interface Country {
  name: string;
  postalCode: string;
  states: State[];
}

export const countries: Country[] = [
  {
    name: "United States",
    postalCode: "US",
    states: [
      State.Alabama, State.Alaska, State.Arizona, State.Arkansas,
      State.California, State.Colorado, State.Connecticut, State.Delaware,
      State.DistrictOfColumbia, State.Florida, State.Georgia, State.Hawaii,
      State.Idaho, State.Illinois, State.Indiana, State.Iowa,
      State.Kansas, State.Kentucky, State.Louisiana, State.Maine,
      State.Maryland, State.Massachusetts, State.Michigan, State.Minnesota,
      State.Mississippi, State.Missouri, State.Montana, State.Nebraska,
      State.Nevada, State.NewHampshire, State.NewJersey, State.NewMexico,
      State.NewYork, State.NorthCarolina, State.NorthDakota, State.Ohio,
      State.Oklahoma, State.Oregon, State.Pennsylvania, State.RhodeIsland,
      State.SouthCarolina, State.SouthDakota, State.Tennessee, State.Texas,
      State.Utah, State.Vermont, State.Virginia, State.Washington,
      State.WestVirginia, State.Wisconsin, State.Wyoming,
    ],
  },
  {
    name: "Canada",
    postalCode: "CA",
    states: [
      State.Alberta, State.BritishColumbia, State.Manitoba, State.NewBrunswick,
      State.NewfoundlandAndLabrador, State.NorthwestTerritories, State.NovaScotia,
      State.Nunavut, State.Ontario, State.PrinceEdwardIsland, State.Quebec,
      State.Saskatchewan, State.Yukon,
    ],
  },
  {
    name: "Mexico",
    postalCode: "MX",
    states: [
      State.Aguascalientes, State.BajaCalifornia, State.BajaCaliforniaSur,
      State.Campeche, State.Chiapas, State.Chihuahua, State.Coahuila,
      State.Colima, State.Durango, State.Guanajuato, State.Guerrero,
      State.Hidalgo, State.Jalisco, State.MexicoCity, State.MexicoState,
      State.Michoacan, State.Morelos, State.Nayarit, State.NuevoLeon,
      State.Oaxaca, State.Puebla, State.Queretaro, State.QuintanaRoo,
      State.SanLuisPotosi, State.Sinaloa, State.Sonora, State.Tabasco,
      State.Tamaulipas, State.Tlaxcala, State.Veracruz, State.Yucatan,
      State.Zacatecas,
    ],
  },
];

export const getCountryByState = (state: State): Country =>
  countries.find(g => g.states.includes(state))!;

const statePostalCodes: Record<State, string> = {
  [State.Alabama]: "AL",
  [State.Alaska]: "AK",
  [State.Arizona]: "AZ",
  [State.Arkansas]: "AR",
  [State.California]: "CA",
  [State.Colorado]: "CO",
  [State.Connecticut]: "CT",
  [State.Delaware]: "DE",
  [State.DistrictOfColumbia]: "DC",
  [State.Florida]: "FL",
  [State.Georgia]: "GA",
  [State.Hawaii]: "HI",
  [State.Idaho]: "ID",
  [State.Illinois]: "IL",
  [State.Indiana]: "IN",
  [State.Iowa]: "IA",
  [State.Kansas]: "KS",
  [State.Kentucky]: "KY",
  [State.Louisiana]: "LA",
  [State.Maine]: "ME",
  [State.Maryland]: "MD",
  [State.Massachusetts]: "MA",
  [State.Michigan]: "MI",
  [State.Minnesota]: "MN",
  [State.Mississippi]: "MS",
  [State.Missouri]: "MO",
  [State.Montana]: "MT",
  [State.Nebraska]: "NE",
  [State.Nevada]: "NV",
  [State.NewHampshire]: "NH",
  [State.NewJersey]: "NJ",
  [State.NewMexico]: "NM",
  [State.NewYork]: "NY",
  [State.NorthCarolina]: "NC",
  [State.NorthDakota]: "ND",
  [State.Ohio]: "OH",
  [State.Oklahoma]: "OK",
  [State.Oregon]: "OR",
  [State.Pennsylvania]: "PA",
  [State.RhodeIsland]: "RI",
  [State.SouthCarolina]: "SC",
  [State.SouthDakota]: "SD",
  [State.Tennessee]: "TN",
  [State.Texas]: "TX",
  [State.Utah]: "UT",
  [State.Vermont]: "VT",
  [State.Virginia]: "VA",
  [State.Washington]: "WA",
  [State.WestVirginia]: "WV",
  [State.Wisconsin]: "WI",
  [State.Wyoming]: "WY",
  [State.Alberta]: "AB",
  [State.BritishColumbia]: "BC",
  [State.Manitoba]: "MB",
  [State.NewBrunswick]: "NB",
  [State.NewfoundlandAndLabrador]: "NL",
  [State.NorthwestTerritories]: "NT",
  [State.NovaScotia]: "NS",
  [State.Nunavut]: "NU",
  [State.Ontario]: "ON",
  [State.PrinceEdwardIsland]: "PE",
  [State.Quebec]: "QC",
  [State.Saskatchewan]: "SK",
  [State.Yukon]: "YT",
  [State.Aguascalientes]: "AGU",
  [State.BajaCalifornia]: "BCN",
  [State.BajaCaliforniaSur]: "BCS",
  [State.Campeche]: "CAM",
  [State.Chiapas]: "CHP",
  [State.Chihuahua]: "CHH",
  [State.Coahuila]: "COA",
  [State.Colima]: "COL",
  [State.Durango]: "DUR",
  [State.Guanajuato]: "GUA",
  [State.Guerrero]: "GRO",
  [State.Hidalgo]: "HID",
  [State.Jalisco]: "JAL",
  [State.MexicoCity]: "CMX",
  [State.MexicoState]: "MEX",
  [State.Michoacan]: "MIC",
  [State.Morelos]: "MOR",
  [State.Nayarit]: "NAY",
  [State.NuevoLeon]: "NLE",
  [State.Oaxaca]: "OAX",
  [State.Puebla]: "PUE",
  [State.Queretaro]: "QUE",
  [State.QuintanaRoo]: "ROO",
  [State.SanLuisPotosi]: "SLP",
  [State.Sinaloa]: "SIN",
  [State.Sonora]: "SON",
  [State.Tabasco]: "TAB",
  [State.Tamaulipas]: "TAM",
  [State.Tlaxcala]: "TLA",
  [State.Veracruz]: "VER",
  [State.Yucatan]: "YUC",
  [State.Zacatecas]: "ZAC",
};

export const getPostalCode = (state: State): string => statePostalCodes[state];
